import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const config = require("../config.json");

export default class Challenge extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedChallenge: {
      challengeName_da: "",
      challengeName_en: "",
      challengeHidden: false,
      description_da: "",
      description_en: "",
      startDate: 0,
      endDate: 0,
      activityPacks: { defaultPack: "" },
      quizPacks: { defaultPack: "" },
      notificationPack: "",
      challengeImage: "",
      activitiesPerPeriod: 0,
      amountOfQuizzesPerDay: 0,
      roundAmount: 0,
      timePeriod: 0,
      timePeriodName: "",
    },
    activityPacks: [],
    notificationPacks: [],
  };

  componentDidMount() {
    const startDate = new Date(this.props.challenge.startDate * 1000);

    startDate.setSeconds(null);
    startDate.setMilliseconds(null);

    startDate.setMinutes(
      startDate.getMinutes() - startDate.getTimezoneOffset()
    );
    const formattedStartDate = startDate.toISOString().slice(0, -1);

    const endDate = new Date(this.props.challenge.endDate * 1000);
    endDate.setSeconds(null);
    endDate.setMilliseconds(null);

    endDate.setMinutes(endDate.getMinutes() - endDate.getTimezoneOffset());
    const formattedEndDate = endDate.toISOString().slice(0, -1);

    this.setState({
      updatedChallenge: {
        ...this.props.challenge,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        timePeriodName: this.props.challenge.timePeriodName ?? "day",
        activityPacks: this.props.challenge.activityPacks ?? {
          defaultPack: "",
        },
        quizPacks: this.props.challenge.quizPacks ?? { defaultPack: "" },
      },
    });
    this.setState({
      activityPacks: this.props.activityPacks,
      notificationPacks: this.props.notificationPacks,
    });
  }

  handleEditSave = (event, challenge, companies) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateChallenge(challenge, companies);
    this.setState({ selectedCompanies: [] });
  };

  handleChallengeEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let difference = 0;

    if (target.name == "endDate") {
      difference =
        parseInt(this.props.convertUnix(value)) -
        parseInt(this.props.convertUnix(this.state.updatedChallenge.startDate));
    } else if (target.name == "startDate") {
      difference =
        parseInt(this.props.convertUnix(this.state.updatedChallenge.endDate)) -
        parseInt(this.props.convertUnix(value));
    } else {
      difference =
        parseInt(this.props.convertUnix(this.state.updatedChallenge.endDate)) -
        parseInt(this.props.convertUnix(this.state.updatedChallenge.startDate));
    }

    let timePeriod = this.state.updatedChallenge.timePeriod;
    if (target.name == "timePeriod") {
      timePeriod = value;
    }

    let roundAmount = difference / parseInt(timePeriod);

    if (isNaN(roundAmount) || roundAmount < 0) {
      roundAmount == 0;
    }

    this.setState({
      updatedChallenge: {
        ...this.state.updatedChallenge,
        [name]: value,
        roundAmount: roundAmount,
      },
    });
  }

  onActivityPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;
    if (select.id === `${this.state.updatedChallenge.id}activityPackDefault`) {
      this.setState({
        updatedChallenge: {
          ...this.state.updatedChallenge,
          activityPacks: {
            ...this.state.updatedChallenge.activityPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const period = parseInt(
        select.id.split(`${this.state.updatedChallenge.id}activityPack`)[1]
      );

      this.setState({
        updatedChallenge: {
          ...this.state.updatedChallenge,
          activityPacks: {
            ...this.state.updatedChallenge.activityPacks,
            [period]: value,
          },
        },
      });
    }
  };

  onQuizPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === `${this.state.updatedChallenge.id}quizPackDefault`) {
      this.setState({
        updatedChallenge: {
          ...this.state.updatedChallenge,
          quizPacks: {
            ...this.state.updatedChallenge.quizPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const period = parseInt(
        select.id.split(`${this.state.updatedChallenge.id}quizPack`)[1]
      );
      this.setState({
        updatedChallenge: {
          ...this.state.updatedChallenge,
          quizPacks: {
            ...this.state.updatedChallenge.quizPacks,
            [period]: value,
          },
        },
      });
    }
  };

  render() {
    const defaultActivityPack = this.props.activityPacks.find((c) => {
      return c.id == this.props.challenge?.activityPacks?.defaultPack;
    });

    const defaultQuizPack = this.props.quizPacks.find((c) => {
      return c.id == this.props.challenge?.quizPacks?.defaultPack;
    });

    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <Fragment>
          <a
            href="/"
            onClick={(e) => {
              this.handleChallengeEdit(e, this.props.challenge);
            }}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteChallenge(this.props.challenge.id, event)
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <>
            <div className="column">
              <p className="product-id">id: {this.props.challenge.id}</p>
              <p>Navn dansk</p>
              <input
                className="input is-medium"
                type="text"
                name="challengeName_da"
                value={this.state.updatedChallenge.challengeName_da}
                onChange={this.handleInputChange}
              />
              <p>Navn engelsk</p>
              <input
                className="input is-medium"
                type="text"
                name="challengeName_en"
                value={this.state.updatedChallenge.challengeName_en}
                onChange={this.handleInputChange}
              />
              <p>Billede</p>
              <select
                name="challengeImage"
                value={this.state.updatedChallenge.challengeImage}
                onChange={this.handleInputChange}
              >
                <option value=""></option>
                {this.props.challengeImages.map((challengeImage) => {
                  return (
                    <option key={challengeImage.Key} value={challengeImage.Key}>
                      {challengeImage.Key}
                    </option>
                  );
                })}
              </select>
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="challengeHidden"
                id={this.state.updatedChallenge.id + "challengeHidden"}
                value={this.state.updatedChallenge.challengeHidden}
                checked={this.state.updatedChallenge.challengeHidden}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedChallenge.id + "challengeHidden"}
                style={{ marginLeft: 5 }}
              >
                Skjul challenge
              </label>
              <p>Start</p>
              <input
                className="input is-medium"
                type="datetime-local"
                name="startDate"
                value={this.state.updatedChallenge.startDate}
                onChange={this.handleInputChange}
              />
              <p>Slut</p>
              <input
                className="input is-medium"
                type="datetime-local"
                name="endDate"
                value={this.state.updatedChallenge.endDate}
                onChange={this.handleInputChange}
              />
              <p>Tidsperiode i sekunder</p>
              <input
                className="input is-medium"
                type="text"
                name="timePeriod"
                value={this.state.updatedChallenge.timePeriod}
                onChange={this.handleInputChange}
              />
              Tidsperiode navn
              <br />
              <select
                className="select is-medium"
                type={"text"}
                name={"timePeriodName"}
                id={"timePeriodName"}
                onChange={this.handleInputChange}
                value={this.state.updatedChallenge.timePeriodName ?? "day"}
              >
                <option value={"day"}>Dag</option>
                <option value={"week"}>Uge</option>
                <option value={"round"}>Runde</option>
              </select>
              <>
                <div>Grundpakke</div>
                <select
                  className="select is-medium"
                  name={`${this.state.updatedChallenge.id}activityPackDefault`}
                  id={`${this.state.updatedChallenge.id}activityPackDefault`}
                  onChange={this.onActivityPackChange}
                  defaultValue={
                    this.state.updatedChallenge.activityPacks.defaultPack
                      ? this.state.updatedChallenge.activityPacks.defaultPack
                      : "def"
                  }
                >
                  <option id={"def"} value=""></option>
                  {this.props.activityPacks.map((ap) => {
                    return (
                      <option key={ap.id} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              {Array.from(
                { length: parseInt(this.state.updatedChallenge.roundAmount) },
                (_, index) => index + 1
              ).map((period) => {
                return (
                  <div key={`${this.state.updatedChallenge.id}${period}`}>
                    <div>
                      {this.state.updatedChallenge.timePeriodName} {period}
                    </div>
                    <select
                      className="select is-medium"
                      name={`${this.state.updatedChallenge.id}activityPack${period}`}
                      id={`${this.state.updatedChallenge.id}activityPack${period}`}
                      onChange={this.onActivityPackChange}
                      defaultValue={
                        this.state.updatedChallenge.activityPacks[period]
                          ? this.state.updatedChallenge.activityPacks[period]
                          : "def"
                      }
                    >
                      <option id={"def"} value=""></option>
                      {this.props.activityPacks.map((ap) => {
                        return (
                          <option key={ap.id + period} value={ap.id}>
                            {ap.packName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}
              <>
                <div>Quiz Grundpakke</div>
                <select
                  className="select is-medium"
                  name={`${this.state.updatedChallenge.id}quizPackDefault`}
                  id={`${this.state.updatedChallenge.id}quizPackDefault`}
                  onChange={this.onQuizPackChange}
                  defaultValue={
                    this.state.updatedChallenge.quizPacks?.defaultPack
                      ? this.state.updatedChallenge.quizPacks.defaultPack
                      : "def"
                  }
                >
                  <option id={"def"} value=""></option>
                  {this.props.quizPacks.map((ap) => {
                    return (
                      <option key={ap.id} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              {Array.from(
                { length: parseInt(this.state.updatedChallenge.roundAmount) },
                (_, index) => index + 1
              ).map((period) => {
                return (
                  <div key={`${this.state.updatedChallenge.id}${period}`}>
                    <div>
                      {this.state.updatedChallenge.timePeriodName} {period}
                    </div>
                    <select
                      className="select is-medium"
                      name={`${this.state.updatedChallenge.id}quizPack${period}`}
                      id={`${this.state.updatedChallenge.id}quizPack${period}`}
                      onChange={this.onQuizPackChange}
                      defaultValue={
                        this.state.updatedChallenge.quizPacks?.[period]
                          ? this.state.updatedChallenge.quizPacks[period]
                          : "def"
                      }
                    >
                      <option id={"def"} value=""></option>
                      {this.props.quizPacks.map((ap) => {
                        return (
                          <option key={ap.id + period} value={ap.id}>
                            {ap.packName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}
              <p>Antal quizzer om dagen</p>
              <input
                type={"number"}
                name={"amountOfQuizzesPerDay"}
                onChange={this.handleInputChange}
                value={this.state.updatedChallenge.amountOfQuizzesPerDay}
              />
              <p>Aktivitetskrav per periode</p>
              <input
                className="input is-medium"
                type="number"
                name="activitiesPerPeriod"
                value={this.state.updatedChallenge.activitiesPerPeriod}
                onChange={this.handleInputChange}
              />
              <textarea
                name="description_da"
                className="textarea"
                placeholder="DANSK beskrivelse"
                value={this.state.updatedChallenge.description_da}
                onChange={this.handleInputChange}
              />
              <textarea
                name="description_en"
                className="textarea"
                placeholder="ENGELSK beskrivelse"
                value={this.state.updatedChallenge.description_en}
                onChange={this.handleInputChange}
              />
              <>
                <div> Notifikationspakke</div>
                <select
                  className="select is-medium"
                  name={`notificationPack`}
                  onChange={this.handleInputChange}
                  value={this.state.updatedChallenge.notificationPack}
                >
                  <option id={""} value=""></option>
                  {this.state.notificationPacks.map((ap, idx) => {
                    return (
                      <option key={ap.id + idx} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              <br />
              <button
                type="submit"
                className="button is-info is-small"
                onClick={(e) => {
                  this.handleEditSave(
                    e,
                    this.state.updatedChallenge,
                    this.state.selectedCompanies
                  );
                }}
              >
                Gem
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="column">
              <p className="product-title">
                {this.props.challenge.challengeName_da}
              </p>

              <p className="product-id">
                <b>Navn engelsk: </b>
                {this.props.challenge.challengeName_en}
              </p>
              <p className="product-id">
                <b>ID:</b> {this.props.challenge.id}
              </p>

              {this.props.challenge.challengeImage && (
                <img
                  className="activity-image"
                  src={`${
                    config.s3.campaignImagesUrl +
                    this.props.challenge.challengeImage
                  }`}
                />
              )}

              <p className="product-id">
                <b>Skjult:</b>{" "}
                {this.props.challenge.challengeHidden ? "Ja" : "Nej"}
              </p>

              <p className="product-id">
                <b>Start: </b>
                {this.props.convertUnix(this.props.challenge.startDate * 1000)}
              </p>
              <p className="product-id">
                <b>Slut: </b>
                {this.props.convertUnix(this.props.challenge.endDate * 1000)}
              </p>
              <p className="product-id">
                <b>Tidsperiode (sekunder):</b> {this.props.challenge.timePeriod}{" "}
                sekunder
              </p>
              <p className="product-id">
                <b>Tidsperiode navn:</b> {this.props.challenge.timePeriodName}
              </p>
              <p className="product-id">
                <b>Beskrivelse Dansk: </b>
                {this.props.challenge.description_da}
              </p>
              <p className="product-id">
                <b>Beskrivelse Engelsk: </b>
                {this.props.challenge.description_en}
              </p>

              <p className="product-id">
                <b>Aktivitetspakker:</b>
                <br />
              </p>
              <p
                key={"deffyq" + this.props.challenge.id}
                className="product-id"
              >
                Faste:{" "}
                {defaultActivityPack ? defaultActivityPack?.packName : "Ingen"}
              </p>
              {this.props.challenge.activityPacks &&
                Object.keys(this.props.challenge.activityPacks).map(
                  (key, idx) => {
                    const packId = this.props.challenge.activityPacks[key];

                    if (!packId || key == "defaultPack") {
                      return;
                    }
                    const pack = this.state.activityPacks.find((c) => {
                      return c.id == packId;
                    });
                    if (!pack) {
                      return;
                    }
                    return (
                      <p
                        key={packId + this.props.challenge.id + idx}
                        className="product-id"
                      >
                        {"Runde " + key + ": " + pack?.packName}
                      </p>
                    );
                  }
                )}

              <p className="product-id">
                <b>Aktivitetskrav per periode: </b>
                {this.props.challenge.activitiesPerPeriod}
              </p>
              <p className="product-id">
                <b>Quizpakker:</b>
                <br />
              </p>
              <p key={"deffy" + this.props.challenge.id} className="product-id">
                Faste: {defaultQuizPack ? defaultQuizPack?.packName : "Ingen"}
              </p>
              {this.props.challenge.quizPacks &&
                Object.keys(this.props.challenge.quizPacks).map((key, idx) => {
                  const packId = this.props.challenge.quizPacks[key];

                  if (!packId || key == "defaultPack") {
                    return;
                  }
                  const pack = this.props.quizPacks.find((c) => {
                    return c.id == packId;
                  });
                  if (!pack) {
                    return;
                  }
                  return (
                    <p
                      key={packId + this.props.challenge.id + idx}
                      className="product-id"
                    >
                      {"Runde " + key + ": " + pack?.packName}
                    </p>
                  );
                })}
              <p className="product-id">
                <b>Antal quizzer om dagen: </b>
                {this.props.challenge.amountOfQuizzesPerDay}
              </p>

              <p className="product-id">
                <b>Notifikationspakke: </b>

                {this.props.challenge.notificationPack &&
                this.props.challenge.notificationPack != "N/A"
                  ? this.state.notificationPacks.find(
                      (np) => np.id == this.props.challenge.notificationPack
                    )?.packName
                  : "Ingen"}
              </p>
            </div>
          </>
        )}
      </div>
    );
  }
}
